
<template>
  <div class="main_empty">
    <dl class="noData">
      <dt>
        <img src="../assets/img/afterLoan/noData.png">
      </dt>
      <dd>{{propJson.title}}</dd>
    </dl>
  </div>
</template>

<script>
export default {
  props: ['propJson'],
  data () {
    return {

    }
  },
  components: {

  },

  mounted () {

  },
  watch: {

  },
  methods: {

  }
}
</script>
<style scoped>
.main_empty {
  width: 100%;
  height: 100%;
  background: #f7f7f7;
}
.noData {
  padding-top: 1.14rem;
  width: 100%;
  height: 200px;
  line-height: 100px;
  text-align: center;
}
.noData dt {
  width: 100%;
  height: 1.03rem;
  text-align: center;
}
.noData dt img {
  width: 1.43rem;
  height: 1.22rem;
}
.noData dd {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
  color: #ccc;
  font-size: 0.15rem;
  font-family: PingFangSC;
  font-weight: 400;
  margin-top: 0.1rem;
  display: inline-block;
  width: 1.2rem;
}
.noExchange {
  height: 130px;
  padding-top: 50px;
}
</style>